var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('s-button',_vm._b({attrs:{"color":_vm.value.color,"label":_vm.status || 'unknown',"size":"xs","shape":"pill","theme":"muted","badge":"","emoji":_vm.value.emoji}},'s-button',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }